import React from 'react';
import * as Styled from './styled';
import { useScreenBreakpoint } from 'consts/breakpoints';

export interface OfferDetailsProps {
  locator: string;
  value: string;
  description: string;
}

export const OfferDetails: React.FC<OfferDetailsProps> = (props) => {
  const breakpoint = useScreenBreakpoint();
  const isMobile = breakpoint < 3;

  return (
    <Styled.Root data-auto={props.locator}>
      {isMobile
        ? <Styled.MobileValueText weight="bold">{props.value}</Styled.MobileValueText>
        : <Styled.ValueText weight="bold">{props.value}</Styled.ValueText>
      }
      <Styled.DescriptionText>{props.description}</Styled.DescriptionText>
    </Styled.Root>
  );
};
